import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '@/lib/api';

export interface CapabilityRouteProps {
  /** A capability do plano exigida pela rota (ex.: 'decks'). */
  capability: string;
  children: ReactNode;
}

/**
 * Irmão comercial do ProtectedRoute: o papel abre a porta, o PLANO decide se a
 * sala existe. Sem a capability, o destino é /planos — nunca /login, porque
 * quem chega aqui já está autenticado: a recusa é comercial, não de sessão.
 *
 * Enquanto o /me carrega não se renderiza nada (a janela é curta e o shell já
 * mostra o seu skeleton — um redirect disparado cedo demais mandaria quem é Pro
 * para a vitrine). Se o /me falha — ou chega sem `plan`, do backend anterior ao
 * lote durante o rollout — a rota abre: a borda recusa as chamadas e cada
 * painel mostra o próprio estado de erro com o CTA de upgrade.
 */
export function CapabilityRoute({ capability, children }: CapabilityRouteProps): JSX.Element | null {
  const me = useMe();
  if (me.isPending) return null;

  const capabilities = me.data?.plan?.capabilities;
  if (capabilities && !capabilities.includes(capability)) {
    return <Navigate to="/planos" replace />;
  }
  return <>{children}</>;
}
